module.exports = __webpack_public_path__ + "img/zh-ch.webp";